import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainAttendanceRoutingModule } from './main-attendance-routing.module';

// OTHER MODULE IMPORTS

import { SharedModule } from './../../shared.module';
import { MaterialsModule } from './../../materials.module';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

// IMPORT COMPONENTS

import { MainAttendanceComponent } from './main-attendance.component';
import { AttendanceComponent } from './../attendance.component';
import { AttendanceRowComponent } from './../attendance-row/attendance-row.component';
import { AttendanceDayComponent } from './../attendance-day/attendance-day.component';
import { AttendanceDayTypeComponent } from './../attendance-day-type/attendance-day-type.component';
import { ChangeStatusComponent } from './../change-status/change-status.component';

import { UtilityService } from '../../services/utility.service';
@NgModule({
  declarations: [
    MainAttendanceComponent,
    AttendanceComponent,
    AttendanceRowComponent,
    AttendanceDayComponent,
    AttendanceDayTypeComponent,
    ChangeStatusComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialsModule,
    MainAttendanceRoutingModule
  ],
  exports: [
    AttendanceComponent,
    AttendanceRowComponent,
    AttendanceDayComponent,
    AttendanceDayTypeComponent,
    // ChangeStatusComponent
  ],
  entryComponents: [
    ChangeStatusComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [UtilityService,
    // {
    //   provide: MatDialogRef,
    //   useValue: {}
    // },
    // {
    //   provide: MAT_DIALOG_DATA,
    //   useValue: {}
    // }
  ]
})
export class MainAttendanceModule { }
